var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketCurly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 152.453V104C80 73.125 105.125 48 136 48H184C188.422 48 192 44.422 192 40S188.422 32 184 32H136C96.297 32 64 64.297 64 104V152.453C64 193.531 41.172 230.469 4.422 248.844C1.719 250.203 0 252.969 0 256S1.719 261.797 4.422 263.156C41.172 281.531 64 318.469 64 359.547V408C64 447.703 96.297 480 136 480H184C188.422 480 192 476.422 192 472S188.422 464 184 464H136C105.125 464 80 438.875 80 408V359.547C80 317.203 58.891 278.703 24.062 256C58.891 233.297 80 194.797 80 152.453Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketCurly);
export default __webpack_public_path__ + "static/media/bracket-curly.da3e4a350ebcd575b9dd4259528b4f98.svg";
export { ForwardRef as ReactComponent };